import axios from 'axios';

import {
	FETCH_NEWEST_ARTICLES_PENDING,
	FETCH_NEWEST_ARTICLES_FULFILLED,
	FETCH_NEWEST_ARTICLES_FAILED,
	FETCH_ARTICLES_PENDING,
	FETCH_ARTICLES_FULFILLED,
	FETCH_ARTICLES_FAILED
} from '../constants/articles.actions';
import {
	API_BASE_URL
} from '../constants/api.paths.js';

export const fetchNewestArticlesPending = () => ({
	type: FETCH_NEWEST_ARTICLES_PENDING,
	payload: null
});

export const fetchNewestArticlesFulfilled = articles => ({
	type: FETCH_NEWEST_ARTICLES_FULFILLED,
	payload: {
		articles
	}
});

export const fetchNewestArticlesFailed = () => ({
	type: FETCH_NEWEST_ARTICLES_FAILED,
	payload: null
});


export const fetchNewestArticles = () => {
	return async function(dispatch) {
		dispatch(fetchNewestArticlesPending());

		try {
			const response = await axios(`${API_BASE_URL}/articles`);
			console.log(response)
			dispatch(fetchNewestArticlesFulfilled(response.data.Items));
		} catch(error) {
			console.log(error);
			dispatch(fetchNewestArticlesFailed(500));
		}
	};
};

export const fetchArticlesPending = () => ({
	type: FETCH_ARTICLES_PENDING,
	payload: null
});

export const fetchArticlesFulfilled = articles => ({
	type: FETCH_ARTICLES_FULFILLED,
	payload: {
		articles
	}
});

export const fetchArticlesFailed = () => ({
	type: FETCH_ARTICLES_FAILED,
	payload: null
});


export const fetchArticles = () => {
	return async function(dispatch) {
		dispatch(fetchArticlesPending());

		try {
			const response = await axios(`/api/articles`);
			dispatch(fetchArticlesFulfilled(response.data.Items));
		} catch(error) {
			console.log(error);
			dispatch(fetchArticlesFailed(500));
		}
	};
};
